import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Gallery from '../components/Gallery';
import Staff from '../components/Staff';
import News from '../components/News';
import Access from '../components/Access';

function Home() {
  return (
    <main>
      <Hero />
      <Services />
      <About />
      <Gallery />
      <Staff />
      <News />
      <Access />
    </main>
  );
}

export default Home;
